import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MemoIcon from '@mui/icons-material/Announcement';
import QuestionIcon from '@mui/icons-material/LiveHelp';
import ClotureIcon from '@mui/icons-material/Archive';
import AnnuleClotureIcon from '@mui/icons-material/Unarchive';
import ReclamationLieeIcon from '@mui/icons-material/Link';
import Observateurs from '../Observateurs';
import ActionsSpecifiquesSelect from 'components/Shared/ActionsSpecifiquesSelect';
import ReclamationPicto from '../../ReclamationsPage/ReclamationsSearchResults/ReclamationsTable/ReclamationRow/ReclamationPicto';
import { ReclamationStatut } from 'constants.js';

const styles = {
    root: {
        display: 'flex',
        width: '100%'
    },

    left: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },

    right: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '100%'
    },

    // Les wrappers inline (Link, span requis par Tooltip pour les boutons désactivables)
    // doivent être inline-flex : sinon l'IconButton s'aligne sur la baseline du texte
    // et remonte par rapport aux boutons non enveloppés.
    iconWrapper: {
        display: 'inline-flex'
    }
};

// Survol carré (coins légèrement arrondis) au lieu du survol rond par défaut des IconButton.
// Padding réduit + petite marge pour que le fond de survol n'atteigne pas les bords.
const squareHover = {
    borderRadius: 1,
    padding: '6px',
    margin: '2px'
};

class ActionsBar extends React.Component {

    render() {
        const { classes, reclamation,
            onObservateurClick, onClickAddMemo, onClickAddQuestion, onClickAnnulerCloture, onClickCloturer, onClickReclamationLiee,
            questionDisabled, memoDisabled
        } = this.props;

        const statutCloture = reclamation.statut === ReclamationStatut.ClotureClient || reclamation.statut === ReclamationStatut.ClotureDefinitive;

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        let nonLectureSeule = utilisateurCourant !== undefined && !utilisateurCourant.lectureSeule;

        // La responsabilité des droits de cloture et d'affectation est portée par l'api

        let autoriseAffectation = nonLectureSeule && !statutCloture && reclamation.autoriseAffectation;

        let autoriseQuestion = nonLectureSeule && !statutCloture;

        let autoriseActions = nonLectureSeule && !statutCloture &&
            (
                (reclamation.affectationUtilisateur !== undefined && reclamation.affectationUtilisateur !== null && reclamation.affectationUtilisateur.id === utilisateurCourant.id) &&
                (reclamation.affectationGroupe !== undefined && reclamation.affectationGroupe !== null && (utilisateurCourant.groupes.find(x => x.id === reclamation.affectationGroupe.id) !== undefined))

            );

        let autoriseMemo = nonLectureSeule;

        let autoriseCreationReclamationLiee = nonLectureSeule && utilisateurCourant !== undefined && utilisateurCourant.autoriseCreationReclamationLiee;

        let autoriseObservation = nonLectureSeule;



        return (
            <div className={classes.root}>
                <div className={classes.left}>
                    <Link to="/reclamations#back" className={classes.iconWrapper}>
                        <IconButton aria-label="Retour" size="large" sx={squareHover}>
                            <ArrowBackIcon />
                        </IconButton>
                    </Link>

                    {
                        reclamation.picto !== undefined &&
                        <ReclamationPicto picto={reclamation.picto} onClickAffectation={this.props.onClickAffectation} autoriseAffectation={autoriseAffectation} fromDetail />
                    }

                    {
                        autoriseObservation &&
                        <IconButton aria-label="Observation" onClick={onObservateurClick} size="large" sx={squareHover}>
                            {reclamation.isObservateur ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                    }

                    {
                        autoriseMemo &&
                        <Tooltip title={!memoDisabled ? "Ajouter un mémo" : memoDisabled}>
                            <span className={classes.iconWrapper}>
                                <IconButton onClick={onClickAddMemo} disabled={!!memoDisabled} size="large" sx={squareHover}>
                                    <MemoIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }

                    {
                        autoriseQuestion &&
                        <Tooltip title={!questionDisabled ? "Poser une question" : questionDisabled}>
                            <span className={classes.iconWrapper}>
                                <IconButton onClick={onClickAddQuestion} disabled={!!questionDisabled} size="large" sx={squareHover}>
                                    <QuestionIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }

                    {
                        autoriseCreationReclamationLiee &&
                        <Tooltip title="Créer un dossier après-vente lié">
                            <IconButton onClick={onClickReclamationLiee} size="large" sx={squareHover}>
                                <ReclamationLieeIcon />
                            </IconButton>
                        </Tooltip>
                    }

                    {
                        reclamation.autoriseAnnulationCloture &&
                        <Tooltip title="Annuler la clôture du dossier après-vente">
                            <IconButton onClick={onClickAnnulerCloture} size="large" sx={squareHover}>
                                <AnnuleClotureIcon />
                            </IconButton>
                        </Tooltip>
                    }

                    {
                        reclamation.autoriseCloture && 
                        <Tooltip title="Clôturer le dossier après-vente">
                            <IconButton onClick={onClickCloturer} size="large" sx={squareHover}>
                                <ClotureIcon />
                            </IconButton>
                        </Tooltip>
                    }

                    {
                        !reclamation.autoriseCloture && reclamation.autoriseClotureMessage &&
                        <Tooltip title={reclamation.autoriseClotureMessage}>
                            <span className={classes.iconWrapper}>
                                <IconButton disabled size="large" sx={squareHover}>
                                    <ClotureIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    }

                    {
                        autoriseActions &&
                        <ActionsSpecifiquesSelect reclamationId={reclamation.id} groupeId={reclamation.affectationGroupe.id} reclamationSurBonDeVenteCle={reclamation.reclamationSurBonDeVenteCle} iconButtonSx={squareHover} />
                    }
                </div>

                <div className={classes.right}>
                    <Observateurs reclamation={reclamation} />
                </div>
            </div>
        );
    }
}

ActionsBar.propTypes = {
    classes: PropTypes.object.isRequired,
    onClickAddMemo: PropTypes.func.isRequired,
    onClickAddQuestion: PropTypes.func.isRequired,
    onClickAffectation: PropTypes.func.isRequired,
    onClickCloturer: PropTypes.func.isRequired,
    onClickAnnulerCloture: PropTypes.func.isRequired,
    onClickReclamationLiee: PropTypes.func.isRequired,
    reclamation: PropTypes.object.isRequired
};

export default withStyles(styles)(ActionsBar);